import { ChangeDetectorRef, Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { StaffProvider } from '../../providers/staff/staff';
import { ToastProvider } from '../../providers/toast/toast';
import { StaffDetailPage } from '../staff-detail/staff-detail';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-search-staff',
  templateUrl: 'search-staff.html',
})
export class SearchStaffPage {

  staffs = [];
  message = this.translate.instant("SEARCH_STAFF_MSG");
  categories = [];
  showData = false;
  selectedCategory: string;
  searchStaff: any;
  selRegistrationLogin  : any;

  constructor(public navCtrl: NavController,
    private translate: TranslateService,
    public navParams: NavParams,
    private staffProvider: StaffProvider,
    private toast: ToastProvider,
    private app: App,
    private ref: ChangeDetectorRef
    ) {
      //ref.detach();
      setInterval(() => {
        try{
          this.ref.detectChanges();
        }catch(e){}
      }, 500);

    this.selRegistrationLogin = localStorage.getItem('signup_login')
    if(this.selRegistrationLogin){
      this.showData = true;
      // this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }
    else{
    staffProvider.getStaffCategories().then(val => {
      if (val.status == "success") {
        this.categories = val.data;
        this.getStaffByCate(this.categories[0].name);
      } else {
        this.toast.presentToast(val.message);
      }
      this.showData = true;
    });
  }
  }

  refresh() {
    this.staffs = [];
  }

  setItems(setvalue) {
    this.searchStaff = setvalue.target.value;
  }

  getItems() {
    this.selectedCategory = '0';
    let val = this.searchStaff;
    this.message = this.translate.instant('NO_STAFF_TO_SHOW');
    this.staffs = []
    this.staffProvider.searchStaffs(val).then(val => {
      if (val.status == "success") {
        this.staffs = val.data;
      } else {
        this.toast.presentToast(val.message);
      }
    });
  }

  getStaffByCate(category: string) {
    this.selectedCategory = category;
    this.staffs = []
    this.staffProvider.getStaffByCategories(category).then(val => {
      if (val.status == "success") {
        this.staffs = val.data;
      } else {
        this.toast.presentToast(val.message);
      }
    });
  }

  getObject(s: string) {
    return JSON.parse(s);
  }

  getRating(s: string) {
    if (s && s != "[]") {
      try {
        let obj = JSON.parse(s);
        let num = Math.floor(+obj[0].average_rating);
        return Array(num);
      } catch (err) {
        console.log(err);
      }
    }
  }

  getNonRating(s: string) {
    let obj = JSON.parse(s);
    let num = Math.floor(+obj[0].average_rating);
    return Array(5 - num);
  }

  staffDetail(staff: any) {
    this.app.getRootNav().push(StaffDetailPage, {
      parent: this,
      data: staff
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchStaffPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/search-staff/search-staff.ts